(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('callHistoryCtrl', ['$scope', '$sce', 'httpService', 'prepaidUserInfoService', '$http', 'uteEndpoint', '$rootScope', '$stateParams', '$state', 'transactionHistoryService', 'uteLocale', 'commonService', function ($scope, $sce, httpService, prepaidUserInfoService, $http, uteEndpoint, $rootScope, $stateParams, $state, transactionHistoryService, uteLocale, commonService) {

      $scope.collapse = false;
      $scope.revisedHistory = [];
      var typeList = [];
      $scope.lang = uteLocale.language;
      $scope.customerBillingProvince = "ON"; //default set to EST time zone

      $scope.callSelected = 'allCalls';
      if ($scope.lang == 'en') {
        $scope.originalResponse = transactionHistoryService.getResponse().en.callHistory;
      } else {
        $scope.originalResponse = transactionHistoryService.getResponse().fr.callHistory;
      }
      // determine customer billing province
      _.each(commonService.accountDetails,function(accountDetail) {
        if (accountDetail.accountNumber === prepaidUserInfoService.getBAN()) {
          $scope.customerBillingProvince = accountDetail.billingProvince;
        }
      });


      $.each($scope.originalResponse, function (key, value) {
        var date = new Date(value.date);
        value.customerBillingProvince = $scope.customerBillingProvince;
        value.date = date;
      });

      $.each($scope.originalResponse, function (key, value) {
        typeList.push(value.callType);
      });
      $scope.callOptions = typeList;
      if ($stateParams.callTypeParam) {
        $scope.callSelected = $stateParams.callTypeParam;
        if ($scope.callSelected == 'allCalls' || $scope.callSelected == 'Tous les appels') {
          $scope.callHistoryResponse = $scope.originalResponse;
        } else {
          $.each($scope.originalResponse, function (key, value) {
            if ($stateParams.callTypeParam == value.callType) {
              $scope.revisedHistory.push(value);
            }
          });
          $scope.callHistoryResponse = $scope.revisedHistory;
        }
        document.body.scrollTop = document.documentElement.scrollTop = 500;
      } else {
        $scope.callSelected = 'allCalls';
        $scope.callHistoryResponse = $scope.originalResponse;
        document.body.scrollTop = document.documentElement.scrollTop = 500;
      }

      $scope.filterCallHistory = function () {
        $state.go('myAccount.viewTransactionHistory.call', {
          'callTypeParam': $scope.callSelected
        });

      }
    }]);

})();
